import React from 'react';
import { FaSpinner } from 'react-icons/fa';

interface DeletePopupProps {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
  isLoading?:boolean;

}

const DeletePopup: React.FC<DeletePopupProps> = ({isLoading, isOpen, onClose, onDelete }) => {

  return (
    <div className=" flex items-center justify-center ">
      <div className="bg-white p-6 rounded-lg  ">
        <h2 className="text-xl font-semibold mb-4">Confirm Deletion</h2>
        <p className="mb-6">Are you sure you want to delete this item? This action cannot be undone.</p>
        <div className="flex justify-end">
          <button
            onClick={onClose}
            className="bg-gray-200 hover:bg-gray-300 text-gray-700 px-4 py-2 rounded mr-2"
          >
            Cancel
          </button>
          <button
            onClick={onDelete}
            className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded"
          >
            {isLoading?<p className='flex gap-1 justify-center  items-center'><FaSpinner className="animate-spin mr-2"/> Deleting...</p>:"Delete"}
            
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeletePopup;
